module.exports = __webpack_public_path__ + "static/media/clients-01.7da2cfc2.png";